<template>
  <PlatformLayout :layout-class="platformLayoutClass" title="Программы" :show-guest-banner="false">
    <ProgramsSearchPage />
  </PlatformLayout>
</template>

<script>
import PlatformLayout from '@/components/platform/PlatformLayout.vue';
import ProgramsSearchPage from '@/components/programs/ProgramsSearchPage.vue';
import 'vue-awesome-paginate/dist/style.css';

export default {
  name: 'CuratorPrograms',
  components: { PlatformLayout, ProgramsSearchPage },
  computed: {
    platformLayoutClass() {
      if (['curator', 'expert'].includes(this.$store.state.role)) return 'mainStyle';
      if (['supervisor', 'chief'].includes(this.$store.state.role)) return 'mainStyle3';
      return 'mainStyle1';
    },
  },
};
</script>
